import CustomerInfo from 'types/CustomerInfo';
import { isLocalStorageAvailable, safeGetItem, safeSetItem } from './safeStorage';

const fallbackMemoryMap = new Map<string, CustomerInfo>();

// Helper function to generate the storage key consistently
const generateCustomerStorageKey = (
  invoiceId: string,
  environment: string
): string => {
  return `${invoiceId}_${environment}_customerInfo`;
};

export function getCustomerFromStorage(
  invoiceId: string,
  environment: string
): CustomerInfo | null {
  if (isLocalStorageAvailable()) {
    const storageKey = generateCustomerStorageKey(invoiceId, environment);
    const customerInfoJson = safeGetItem(storageKey);
    if (!customerInfoJson) return null;
    try {
      return JSON.parse(customerInfoJson);
    } catch (e) {
      return null;
    }
  } else {
    return fallbackMemoryMap.get(invoiceId) || null;
  }
}

export function putCustomerInStorage(
  invoiceId: string,
  customerInfo: CustomerInfo,
  environment: string
): void {
  if (isLocalStorageAvailable()) {
    const storageKey = generateCustomerStorageKey(invoiceId, environment);
    safeSetItem(storageKey, JSON.stringify(customerInfo));
  } else {
    fallbackMemoryMap.set(invoiceId, customerInfo);
  }
}
